/**
 * For wrapping buttons and passing in a function
 * Adds hover lift animation and color change
 *
 */

import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const WrapButton = ({ className, clickFunction, children, color, type }) => (
  <button
    className={classNames(
      "group",
      "inline-block",
      "px-[0.2em] pt-[0.1em] pb-[0.05em]",
      "font-bold",
      "uppercase whitespace-nowrap",
      "transition-all duration-200 ease-in-out",
      "hover:scale-110 hover:shadow-strong",
      color === "black" && "bg-black text-white hover:text-green",
      color === "green" && "bg-green text-black",
      className
    )}
    onClick={() => clickFunction}
    type={type}
  >
    {children}
  </button>
);

WrapButton.defaultProps = {
  color: "black",
  type: "button",
};

WrapButton.propTypes = {
  /** Color: black (default), green */
  color: PropTypes.string,
  children: PropTypes.node,
  /** Pass in a function */
  clickFunction: PropTypes.func,
  /** href */
  href: PropTypes.string,
  /** type. default = button */
  type: PropTypes.string,
};

export default WrapButton;
